import { dataTestIds } from "data-testids";
import React from "react";
import { CheckIcon } from "assets";

export interface IThumbnailBarItemProps {
  thumbnail: string;
  index: number;
  selectedThumbnail: number;
  selectThumbnail: (thumbnail: number) => void;
}

const KEYBOARD_KEY_ENTER = "Enter";

export const ThumbnailBarItem: React.FC<
  React.PropsWithChildren<IThumbnailBarItemProps>
> = ({ thumbnail, index, selectedThumbnail, selectThumbnail }) => {
  const handleKeyPress = (event: React.KeyboardEvent): void => {
    event.preventDefault();

    if (event.key === KEYBOARD_KEY_ENTER) {
      selectThumbnail(index);
    }
  };
  const isSelected = index === selectedThumbnail;

  return (
    <div
      className={`c-thumbnail-bar-item ${
        isSelected ? "c-thumbnail-bar-item--selected" : ""
      }`}
      onClick={() => selectThumbnail(index)}
      onKeyUp={handleKeyPress}
      tabIndex={0}
      data-testId={dataTestIds.profile["Media.ThumbnailBar.ThumbnailBarItem"]}
    >
      <div className="c-thumbnail-bar-item__layer text-white">
        {isSelected && (
          <div className="absolute right-2 top-2 flex h-[40px] w-[40px] items-center justify-center rounded-full bg-green-mint">
            <CheckIcon />
          </div>
        )}
      </div>
      <img
        className="c-thumbnail-bar-item__image"
        src={thumbnail}
        alt={thumbnail}
      />
    </div>
  );
};
